import React, { useState } from "react";
import { Box } from "@mui/material";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { CreditNoteEntryFormColumns } from "../../../data/DynamicTable/Collumns";
import { AccountsandFinanceurl } from "../../../config";
import { allCreditNotesView } from "../../../data/Axios/queries";
import CreditNoteEntryForm from "./form";
import CreditNoteDetailDialog from "./CreditNoteDetailDialog";

const base_url = AccountsandFinanceurl.uri;

function CreditNoteList() {
    const [openCreditNoteDialog, setOpenCreditNoteDialog] = useState(false);
    const [selectedCreditNote, setSelectedCreditNote] = useState(null);
    const [refreshTable, setRefreshTable] = useState(null);

    const actions = {
        entity: "Credit Note",
        edit: {
            key: "EDIT",
            button_name: "Edit",
            Show_Button: true,
            permission: "EditPermission",
        },
        add: {
            key: "ADD",
            button_name: "Credit Note",
            Show_Button: true,
            permission: "CreatePermission",
        },
        activateDeactivate: {
            key: "ACTIVATEDEACTIVATE",
            button_name: "Deactivate",
            Show_Button: true,
            permission: "ActivatePermission",
            inputObjectName: "activateDeactivateCreditNotes",
            roleGroupId: [1, 2, 3, 4],
            returnScalar: true,
        },
        ViewCreditNoteLines: {
            key: "VIEWCREDITNOTELINES",
            button_name: "View Lines",
            Show_Button: true,
            permission: "hasNoPermission",
            roleGroupId: [1, 2, 3, 4],
            onClick: (row, refresh) => {
                setRefreshTable(() => refresh);
                setSelectedCreditNote(row);
                setOpenCreditNoteDialog(true);
            },
        },
        PrintCreditNote: {
            key: "PRINTCREDITNOTE",
            button_name: "Print",
            Show_Button: true,
            permission: "hasNoPermission",
            roleGroupId: [1, 2, 3, 4],
        },
        approveCreditNote: {
            key: "APPROVECREDITNOTE",
            button_name: "Approve",
            Show_Button: true,
            permission: "hasNoPermission",
            roleGroupId: [1, 2, 3, 4],
        },
    };

    return (
        <Box m="2px" p="1rem">
            <DynamicTable
                title="Credit Notes"
                subtitle="View all Credit Notes, create, edit or view details"
                columns={CreditNoteEntryFormColumns}
                FormComponent={CreditNoteEntryForm}
                query={allCreditNotesView}
                base_url={base_url}
                actions={actions}
            />

            {openCreditNoteDialog && (
                <CreditNoteDetailDialog
                    open={openCreditNoteDialog}
                    onClose={() => {
                        setOpenCreditNoteDialog(false);
                        if (refreshTable) refreshTable();
                    }}
                    creditNoteData={selectedCreditNote}
                    refetchData={() => {
                        if (refreshTable) refreshTable();
                    }}
                />
            )}
        </Box>
    );
}

export default CreditNoteList;
